<template>
    <InformeCard title="Resumen">
        <div class="d-flex">
            <Button class="mr-2" :class="isActive(1)" @click="tabId = 1">Renovaciones</Button>
            <Button :class="isActive(2)" @click="tabId = 2">Tipos de venta</Button>
        </div>
            <RenovacionesComponent v-if="valores && valores.renovaciones && tabId == 1" :valores="valores.renovaciones" id="renovaciones" class="width-responsive" />
            <TipoVentaComponent v-if="valores && valores.tipos && tabId == 2" :valores="valores.tipos" id="tipo-ventas" class="width-responsive" />
    </InformeCard>
</template>

<script>
import InformeCard from "../InformeCard";
import RenovacionesComponent from '@/components/backend/estadisticas/abonos/RenovacionesComponent';
import TipoVentaComponent from '@/components/backend/estadisticas/abonos/TipoVentaComponent'

export default {
    name: "GraficosComponent",
    props: ['lista_id', 'fecha_inicio', 'fecha_fin'],
    data() {
        return {
            tabId: 1,
            loading: false,
            valores: null
        }
    },
    methods: {
        isActive(tabId) {
            return { "active": this.tabId == tabId };
        },
        getRenovacionesAndTipos() {
            this.loading = true;

            const params = {
                filters : {},
                lista_id: this.lista_id
            };

            if (this.fecha_inicio && this.fecha_fin) {
                params.filters.fecha_inicio = this.fecha_inicio;
                params.filters.fecha_fin = this.fecha_fin;
            }

            this.$store.dispatch(this.config.getVuexAlias('back.abonos.informe.renovaciones-tipos'), params).then(res => {
                this.valores = res.data.data;
            }).finally(() => this.loading = false);
        }
    },
    created() {
        this.getRenovacionesAndTipos();
    },
    components: { InformeCard, RenovacionesComponent, TipoVentaComponent },
}
</script>

<style scoped>
     @media (max-width: 700px) {
        .width-responsive {
            width: 320px;
        }
     }
</style>